export enum ReportsDashboardActions {
    FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA',
}
